//config.js
// export const API_URL = 'http://127.0.0.1:8000/api'
// export const IMG_URL = 'http://localhost:8000/storage'
// export const RAZORPAY_URL = 'http://localhost:8000/api/razorpay/order'
// export const PAYPAL_URL = 'http://127.0.0.1:8000/api/paypal/create-order'

// // // export const GPAY_URL = 'http://localhost:8000/api/razorpay/order'

//config.js

export const API_URL = "https://shentihilnathan.com/api";
export const IMG_URL = 'https://shentihilnathan.com/storage'
export const RAZORPAY_URL = 'https://shentihilnathan.com/api/razorpay/order'
export const PAYPAL_URL = 'https://shentihilnathan.com/api/paypal/create-order'

// TESTING
